export default __webpack_public_path__ + "static/media/servicios1.e2b1d047.jpg";